import { Component, OnInit, ViewChild } from '@angular/core';
import { PrimaryButtonComponent } from "../../../../shared/components/primary-button/primary-button.component";
import { ToastComponent } from "../../../../shared/components/toast/toast.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { UserService } from '../../../../core/api/user.service';
import { Router, RouterLink } from '@angular/router';
import { finalize, firstValueFrom } from 'rxjs';
import { LogoComponent } from "../../../../shared/components/logo/logo.component";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { DateConversionService } from '../../../../core/services/date-conversion.service';
import { UserDataService } from '../../../../core/services/user-data.service';

@Component({
  selector: 'app-account-deleted',
  standalone: true,
  imports: [PrimaryButtonComponent, ToastComponent, TranslocoPipe, LogoComponent, CommonModule, FormsModule, CustomButtonComponent, RouterLink],
  templateUrl: './account-deleted.component.html',
  styleUrl: './account-deleted.component.css'
})
export class AccountDeletedComponent implements OnInit {
  confirmStep: 1 | 2 = 1;
  confirmChecked = false;
  isLoading = false;

  // optional: show scheduled date if your backend provides it
  deletionDateLabel: string | null = null;

  constructor(
    private userService: UserService,
    private router: Router,
    private apiError: ApiErrorService,
    private dateConversion: DateConversionService,
    private userData: UserDataService
  ) { }

  @ViewChild(ToastComponent) toast?: ToastComponent;

  ngOnInit(): void {
    this.loadDeletionInfo();
  }

  startDoubleConfirm(): void {
    this.confirmStep = 2;
    this.confirmChecked = false;
  }

  cancelDoubleConfirm(): void {
    this.confirmStep = 1;
    this.confirmChecked = false;
  }

  async reactivateAccount(): Promise<void> {
    if (this.isLoading || !this.confirmChecked) return;

    this.isLoading = true;

    try {
      await firstValueFrom(this.userService.cancelDeleteAccount());
      await this.userData.loadUserData();

      this.router.navigate(['/dashboard']);
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';

        if (error.error.code === 'SVC-4004') {
          await this.userData.loadUserData();
          this.router.navigate(['/dashboard']);
          return;
        }
      }
      this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);

    }
    this.isLoading = false;
  }

  private async loadDeletionInfo(): Promise<void> {
    await this.userData.loadUserData();
    const user = this.userData.getUser();
    if (user?.deleted_at == null) {
      this.router.navigate(['/dashboard']);
    }

    var date = new Date(user!.deleted_at!)
    date.setDate(date.getDate() + 30);

    this.deletionDateLabel = this.dateConversion.isoToFormattedDate(this.dateConversion.dateToIso(date));
  }
}
